import Translator from '../../core/i18n';

export const FileSectionNumbers = ({
    files_added_activities: { label: "FilesAddedActivities", value: 0 },
    files_added_communication_tools: { label: "FilesAddedCommunicationTools", value: 1 },
    personal_files: { label: "PersonalFiles", value: 2 },
    other_files: { label: "OtherFiles", value: 3 }
});

export const FileSections = (T: Translator) => ({
    files_added_activities: { label: T.t('r_files_added_activities'), value: "FilesAddedActivities" },
    files_added_communication_tools: { label: T.t('r_files_added_communication_tools'), value: "FilesAddedCommunicationTools" },
    personal_files: { label: T.t('r_personal_files'), value: "PersonalFiles" },
    other_files: { label: T.t('r_other_files'), value: "OtherFiles" }
});

export const ActivityAddedFileTabNumbers = ({
    activity_files: 'activityFiles',
    assignment_files: 'assignmentFiles',
    deleted_files: 'deletedFiles',
});